import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { DocumentsService } from 'src/app/services/document.service';
import Swal from "sweetalert2";
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-informacion',
  standalone: true,
  imports: [
    QuillModule, // Configuración de Quill
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './informacion.component.html',
  styleUrl: './informacion.component.css'
})
export class InformacionComponent implements OnInit, OnChanges {
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) textoEditado: any;
  @Input({required: true}) expedienteCliente: any;
  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  // textoEditado: string = ''; // Aquí se guarda el contenido del editor
  textActive: string = 'general'
  quillModules = {
    imageResize: true, // Activar redimensionamiento de imágenes
  };
  contenidoSanitizado: SafeHtml;
  alimentacionMacros: boolean = true;
  
  constructor(
    private documentService: DocumentsService,
    private sanitizer: DomSanitizer) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.expedienteCliente) {
      this.sanitizarContenido();
    }
  }
  ngOnInit(): void {
  }

  sanitizarContenido(): void {
    this.contenidoSanitizado = this.sanitizer.bypassSecurityTrustHtml(this.textoEditado);
  }
  
  updateProgramaDocument()
  {
    console.log(this.detallePrograma)
    console.log(this.textoEditado)
    let programaDocument: any = {
      informacion: this.textoEditado
    }
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'La información del programa ha sido actualizado.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });

        // Emitir el evento hacia el padre
        this.programaActualizado.emit();
        // Swal.fire(
        //   "¡Listo!",
        //   "La información del programa ha sido actualizado.",
        //   "success"
        // )
      }
    })
  }
  changeTextActive(value: string)
  {
    this.textActive = value;
  }

  // cambiaTipoAlimentacion(tipo){
  //   debugger
  //     this.alimentacionMacros = tipo
  //     const index = this.expedienteCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
  //     let programas = [...this.expedienteCliente.expediente.programas];
  //     programas[index].configuracionPrograma.alimentacionPorMacros = tipo;
  //     let expedienteClienteDocument: any = {
  //       expediente: {
  //         programas: programas
  //       }
  //     }
  //     console.log('expendiente actualizado')
  // }

}
